import { type RovoChatMentionResource } from './rovo-chat-mention-resource';

export type AgentMentionAnalyticsEvent =
	| {
			action: 'opened' | 'searched';
			queryLength: number;
			agentResultCount: number;
			peopleResultCount: number;
	  }
	| {
			action: 'selected';
			resultType: 'agent';
			agentId: string;
			agentIsVerified?: boolean;
			position?: number;
			queryLength: number;
	  }
	| {
			action: 'selected';
			resultType: 'person';
			position?: number;
			queryLength: number;
	  };

type OnAgentMentionAnalyticsEvent = (event: AgentMentionAnalyticsEvent) => void;

const analyticsCallbacks = new WeakMap<RovoChatMentionResource, OnAgentMentionAnalyticsEvent>();

export const agentMentionAnalyticsCallbacks = {
	set(resource: RovoChatMentionResource, callback: OnAgentMentionAnalyticsEvent | undefined): void {
		if (callback) {
			analyticsCallbacks.set(resource, callback);
			return;
		}
		analyticsCallbacks.delete(resource);
	},
	get(resource: RovoChatMentionResource): OnAgentMentionAnalyticsEvent | undefined {
		return analyticsCallbacks.get(resource);
	},
};
